import { InvalidUrlError } from '@execonline-inc/url';
import { HttpError } from 'ajaxian';
import { Maybe, nothing } from 'maybeasy';
import { SetStateAction } from 'react';
import { AppyError } from '../../../../../../Appy';
import { Resource } from '../../../../../../Resource/Types';
import { StringOption } from '../../../../../Options/Types';
import {
  Filtering,
  Ready,
} from '../../../../../LearningCollections/LearningCollection/ParticipantDynamicTypeaheadSelect/UseParticipantDynamicTypeaheadSelect/Types';
export type FilterOptions = StringOption[];
export type FilterOptionsResource = Resource<FilterOptions>;

export interface Loading {
  kind: 'loading';
  initialValue: Maybe<StringOption>;
}

export interface Filtered {
  kind: 'filtered';
  filterBy: string;
  optionsResource: FilterOptionsResource;
  selectedValue: Maybe<StringOption>;
}

export interface OptionSelected {
  kind: 'option-selected';
  optionsResource: FilterOptionsResource;
  selectedValue: StringOption;
}

export interface Error {
  kind: 'error';
  message: string;
}

export type NewState = SetStateAction<State>;
export type FilterError = HttpError | InvalidUrlError | AppyError;

export type State = Loading | Ready | Filtering | Filtered | OptionSelected | Error;

export const loading = (initialValue: Maybe<StringOption>): Loading => ({
  kind: 'loading',
  initialValue,
});

export const filtered = (
  optionsResource: FilterOptionsResource,
  state: Loading | Filtering,
): Filtered => {
  const staticValues: Pick<Filtered, 'kind' | 'optionsResource'> = {
    kind: 'filtered',
    optionsResource,
  };

  switch (state.kind) {
    case 'loading':
      return {
        ...staticValues,
        filterBy: state.initialValue.map((iv) => iv.value).getOrElseValue(''),
        selectedValue: state.initialValue,
      };
    case 'filtering':
      return {
        ...staticValues,
        filterBy: state.filterBy,
        selectedValue: nothing(),
      };
  }
};

export const optionSelected = (
  selectedValue: StringOption,
  optionsResource: FilterOptionsResource,
): OptionSelected => ({
  kind: 'option-selected',
  optionsResource,
  selectedValue,
});
